import { cssVariables } from "@/utils/utils";
import { Popover } from "antd";
import { tInterval } from "../../../../../../common/utils/translationUtils";

type Props = {
  remainingDays: number;
  popoverContent: React.ReactNode;
};

export const AgentCompetenceRemainingDaysPopover = ({ popoverContent, remainingDays }: Props) => {
  return (
    <Popover placement="left" content={popoverContent}>
      <span
        style={{
          color: remainingDays > 90 ? "inherit" : remainingDays > 14 ? cssVariables.colorYellow : cssVariables.colorRed,
        }}
      >
        <span
          style={{
            fontSize: remainingDays > 90 ? "auto" : remainingDays > 14 ? 16 : 24,
            lineHeight: "24px",
            paddingRight: 4,
          }}
        >
          {remainingDays}
        </span>

        <span>{tInterval("dashboard.agentExpertises.helpers.remainingDaysLabel_interval", remainingDays)}</span>
      </span>
    </Popover>
  );
};
